export const INK = '#172033';
export const MUTED = '#5c6a78';
export const PAPER = '#f4f1ea';
export const LINE = 'rgba(23, 32, 51, 0.12)';

export const goldButtonSx = {
  bgcolor: 'secondary.main',
  color: INK,
  fontWeight: 700,
  textTransform: 'none',
  borderRadius: 999,
  px: 2.75,
  py: 1.1,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: 'secondary.dark',
    boxShadow: 'none',
  },
};
